"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const withJourney_1 = __importDefault(require("../../../hocs/withJourney"));
const FormContext_1 = require("../../../contexts/FormContext");
const Button_1 = __importDefault(require("../../Util/Button"));
const InputError_1 = __importDefault(require("./InputError"));
const SubmitButton = (props) => {
    const formContextData = react_1.useContext(FormContext_1.FormContext);
    const { submitting, setSubmitting, formRef, formData, setErrors, errors } = formContextData;
    const { children, onClick } = props;
    const submitInputRef = react_1.useRef(null);
    const submittingRef = react_1.useRef(false);
    if (!formContextData.inForm) {
        console.error('A <SubmitButton/> can only be used if it is nested within a <Form/>.');
    }
    // These are errors that we cant map to a field of the form.
    const orphanedErrors = errors.filter((formError) => !formData[formError.attribute]);
    const mainError = errors.find((error) => error.attribute === 'main');
    const mainErrorMsg = mainError ? mainError.message : orphanedErrors.map((e) => e.message).join('\n');
    const onClickHandle = react_1.useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!onClick || submittingRef.current) {
            return;
        }
        // submitInputRef.click() will run this.
        submittingRef.current = true;
        // this will show natived error popup
        (_a = submitInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        if (!((_b = formRef.current) === null || _b === void 0 ? void 0 : _b.checkValidity())) {
            submittingRef.current = false;
            return;
        }
        // clear out errors
        setErrors([]);
        setSubmitting(true);
        try {
            yield onClick(e);
        }
        catch (error) {
            console.error(error);
            try {
                const formErrors = yield FormContext_1.responseToFormErrors(error, formContextData);
                setErrors(formErrors);
            }
            catch (_c) {
                //
            }
        }
        setSubmitting(false);
        submittingRef.current = false;
    }), [formContextData, formRef, onClick, setErrors, setSubmitting]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(InputError_1.default, { name: "main", className: "j-main-input-error" }, mainErrorMsg),
        react_1.default.createElement(Button_1.default, Object.assign({}, props, { disabled: submitting || props.disabled, onClick: onClickHandle }),
            (children !== null && children !== void 0 ? children : ('Submit')),
            react_1.default.createElement("input", { type: "submit", className: "hidden", ref: submitInputRef }))));
};
exports.default = withJourney_1.default('j-submit-button', SubmitButton, { onClickHelper: false });
